import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal, NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PaginationData } from '../../service/global.service';
import { DynamicQueryModalComponent } from '../dynamic-query-modal/dynamic-query-modal.component';

@Component({
  selector: 'rc-admin-generic-grid-template',
  templateUrl: './admin-generic-grid-template.component.html',
  styleUrls: ['./admin-generic-grid-template.component.css']
})
export class AdminGenericGridTemplateComponent implements OnInit {
  @Input() gridData: Array<any> = [];
  @Input() gridHeaderMap: Array<any> = [];
  @Input() gridColumnList: Array<string> = [];
  @Input() currencyColumns: Array<string> = [];
  @Input() formatValueColumns: Array<string> = [];
  @Input() columnsNotToShowList: Array<string> = [];
  @Input() actionDropdownConfig: Array<any> = [];

  @Input() valueFormatMap: any = {};
  @Input() paginationData: PaginationData = {
    currentPage: 1,
    pageSize: 10,
    sortOrder: '-1',
    sortColumn: 'id',
  };

  @Input() total: number = 0;

  @Input() showAddColumn: boolean = false;
  @Input() showEditColumn: boolean = false;
  @Input() showDeleteColumn: boolean = false;
  @Input() showActionsColumn: boolean = false;
  @Input() showCopyIcon: boolean = false;
  @Input() showDynamicQueryButton: boolean = false;

  @Input() noGridDataMessage: string = '';
  @Input() dynamicQueryFilterDescription: string = '';

  @Input() filterCriteria: any = { id: -1, type: 'Data Type...' };
  @Input() dynamicQueryFilters: any = {};

  @Output() addClicked = new EventEmitter<any>();
  @Output() editClicked = new EventEmitter<any>();
  @Output() deleteClicked = new EventEmitter<any>();
  @Output() copyClicked = new EventEmitter<any>();
  @Output() actionChanged = new EventEmitter<any>();
  @Output() paginationDataChanged = new EventEmitter<any>();
  @Output() dynamicQueryEmitter = new EventEmitter<any>();

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit(): void { }

  loadAll() {
    this.paginationDataChanged.emit(this.paginationData)
  }

  showFields(field: string) {
    return this.columnsNotToShowList.includes(field);
  }

  onAddClick(rowData: any) {
    this.addClicked.emit(rowData)
  }

  onEditClick(rowData: any) {
    this.editClicked.emit(rowData)
  }

  onDeleteClick(rowData: any) {
    this.deleteClicked.emit(rowData)
  }

  onCopyClick(rowData: any) {
    this.copyClicked.emit(rowData)
  }

  onActionChange(target: any, rowData: any) {
    const selectedValue = target.value;

    this.actionChanged.emit({
      selectedAction: selectedValue,
      rowData: rowData
    })
  }

  openDynamicQueryModal() {
    const modalRef = this.modalService.open(DynamicQueryModalComponent, { size: 'lg' });
    modalRef.componentInstance.pageLabel = '';
    modalRef.componentInstance.dynamicQueryFilterDescription = this.dynamicQueryFilterDescription;
    modalRef.componentInstance.noText = 'Cancel';
    modalRef.componentInstance.yesText = 'Apply Filters';
    modalRef.componentInstance.enableDynamicQueryFilterSave = false;
    modalRef.componentInstance.filterCriteria = this.filterCriteria;
    modalRef.componentInstance.dynamicQueryFilters = this.dynamicQueryFilters;
    modalRef.result.then(query => {
      if ('X' !== query) {
        this.dynamicQueryFilters = query;
        this.dynamicQueryEmitter.emit({ paginationData: this.paginationData, dynamicQueryFilters: this.dynamicQueryFilters });
      }
    }).catch(error => {
      console.log(error);
    });
  }

  isDate(value: any): boolean {
    const dateFormats = [
      /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
      /^\d{2}\/\d{2}\/\d{4}$/, // MM/DD/YYYY
      /^\d{4}\/\d{2}\/\d{2}$/, // YYYY/MM/DD
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/ // ISO 8601 datetime with optional milliseconds: YYYY-MM-DDTHH:mm:ss.sss...
    ];

    if (typeof value === 'string') {
      for (const format of dateFormats) {
        if (format.test(value)) {
          // Check if the date is valid
          const date = new Date(value);
          return !isNaN(date.getTime());
        }
      }
    }

    return false;
  }

  isCurrency(value: any): boolean {
    return this.currencyColumns.includes(value);
  }

  isNumber(value: any): boolean {
    return typeof value == 'number' ? true : false;
  }

  shouldFormatValue(value: any): boolean {
    return this.formatValueColumns.includes(value);
  }

  formatValues(value: string): string {
    return this.valueFormatMap[value]
  }

  get startItemCount(): number {
    return (this.paginationData.currentPage - 1) * this.paginationData.pageSize + 1;
  }

  get endItemCount(): number {
    return Math.min(this.paginationData.currentPage * this.paginationData.pageSize, this.total);
  }

  onPageSizeChange(selectedValue: string): void {
    this.paginationData.pageSize = parseInt(selectedValue);
    this.paginationData.currentPage = 1;
    this.loadAll();
  }

  onPaginationChange(event: any) {
    this.paginationData.currentPage = event;
    this.loadAll();
  }

}
